"use client"

import { motion } from "framer-motion"

import Logo from "@packages/web/components/Logo"
import { BrandWordmark } from "@packages/web/components/Brand"
import NavLink from "@packages/web/components/NavLink"
import useGetAuthentication from "@packages/base/hooks/use-get-authentication"

import Holygrail from "@consumer-web/components/Holygrail"

const signinWithDashboardRedirect = "/auth?sign=signin&redirect=/dashboard/think"

export default function PageClient() {
  const { data: authentication, isSuccess: isAuthenticationSuccess } = useGetAuthentication({
    redirectIfNotAuthenticated: false,
  })
  const { isAuthenticated } = authentication || {}

  return (
    <Holygrail noHeader noFooter>
      <section className="flex min-h-dvh flex-col items-center justify-center px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex flex-col items-center text-center"
        >
          <Logo className="mb-0 h-20 w-20 md:h-24 md:w-24" />
          <h1 className="mb-4 mt-6 text-5xl font-bold tracking-tight md:text-7xl">
            <BrandWordmark />
          </h1>

          <p className="mb-16 max-w-md text-lg font-light text-foreground/40">
            Un espace simple pour noter une pensée, explorer, et retrouver ton fil.
          </p>

          <div className="flex w-full min-w-[200px] max-w-[360px] flex-col items-center gap-3">
            {!isAuthenticationSuccess ? (
              <div
                aria-hidden
                className="h-11 w-full animate-pulse rounded-md bg-muted"
              />
            ) : isAuthenticated ? (
              <NavLink className="w-full" to="/dashboard/think" variant="default">
                Entrer
              </NavLink>
            ) : (
              <NavLink className="w-full" to={signinWithDashboardRedirect} variant="default">
                Se connecter
              </NavLink>
            )}
          </div>
        </motion.div>
      </section>
    </Holygrail>
  )
}
